module.exports = __webpack_public_path__ + "img/TOOLING_MV.e6351fff.png";